/* Scandic Heat – varukorgs-slider */
(function(){
  'use strict';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var dr=document.querySelector('[data-sh-dr]');
  if(!dr)return;
  var q=function(s){return dr.querySelector(s)};
  var body=q('[data-sh-dr-body]'),empty=q('[data-sh-dr-empty]'),foot=q('[data-sh-dr-foot]');
  var products={};
  function money(c){return Math.round(c/100).toLocaleString('sv-SE').replace(/[  ]/g,' ')+' kr'}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
  function getProduct(h){
    if(products[h])return Promise.resolve(products[h]);
    return fetch(root+'products/'+h+'.js').then(function(r){return r.json()}).then(function(p){products[h]=p;return p}).catch(function(){return null});
  }
  function json(url,data){return fetch(root+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)}).then(function(r){return r.json()})}

  function render(cart){
    var count=cart.item_count;
    document.querySelectorAll('[data-sh-count]').forEach(function(el){el.textContent=count;el.hidden=count===0});
    q('[data-sh-dr-count]').textContent=count?'('+count+')':'';
    if(!count){body.innerHTML='';empty.hidden=false;foot.hidden=true;return Promise.resolve()}
    empty.hidden=true;foot.hidden=false;
    var handles=[];cart.items.forEach(function(i){if(handles.indexOf(i.handle)<0)handles.push(i.handle)});
    return Promise.all(handles.map(getProduct)).then(function(){
      var save=0,html='';
      cart.items.forEach(function(it,idx){
        var p=products[it.handle],v=null;
        if(p){p.variants.forEach(function(x){if(x.id===it.variant_id){v=x}})}
        var cmp=v&&v.compare_at_price>v.price?v.compare_at_price*it.quantity:0;
        if(cmp)save+=cmp-it.final_line_price;
        var props='';if(it.properties){Object.keys(it.properties).forEach(function(k){var val=it.properties[k];if(val&&k.charAt(0)!=='_')props+='<span>'+esc(k)+': '+esc(val)+'</span>'})}
        html+='<div class="sh-dr__it">'
          +'<div class="sh-dr__img">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="" width="80" height="80">':'')+'</div>'
          +'<div class="sh-dr__info"><div class="sh-dr__t">'+esc(it.product_title)+'</div>'
          +'<div class="sh-dr__m">'+(it.variant_title&&it.variant_title!=='Default Title'?'<span>'+esc(it.variant_title)+'</span>':'')+props+'</div>'
          +'<div class="sh-dr__row"><div class="sh-qty"><button type="button" data-sh-qty="'+(idx+1)+'" data-v="'+(it.quantity-1)+'" aria-label="Minska">−</button><span>'+it.quantity+'</span><button type="button" data-sh-qty="'+(idx+1)+'" data-v="'+(it.quantity+1)+'" aria-label="Öka">+</button></div>'
          +'<button type="button" class="sh-dr__rm" data-sh-qty="'+(idx+1)+'" data-v="0">Ta bort</button></div></div>'
          +'<div class="sh-dr__p">'+money(it.final_line_price)+(cmp?'<s>'+money(cmp)+'</s>':'')+'</div>'
          +'</div>';
      });
      body.innerHTML=html;
      q('[data-sh-dr-total]').textContent=money(cart.total_price);
      q('[data-sh-dr-total2]').textContent=money(cart.total_price);
      q('[data-sh-dr-saverow]').hidden=save<=0;
      q('[data-sh-dr-save]').textContent=money(save);
    });
  }
  function refresh(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(render)}
  var lastFocus=null;
  function open(){lastFocus=document.activeElement;dr.classList.add('is-on');dr.setAttribute('aria-hidden','false');document.documentElement.classList.add('sh-lock');setTimeout(function(){var x=q('.sh-dr__x');if(x)x.focus()},50)}
  function close(){dr.classList.remove('is-on');dr.setAttribute('aria-hidden','true');document.documentElement.classList.remove('sh-lock');if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  function busy(on){dr.classList.toggle('is-busy',on)}

  dr.addEventListener('click',function(e){
    if(e.target.closest('[data-sh-dr-close]')){close();return}
    var b=e.target.closest('[data-sh-qty]');
    if(b){busy(true);json('cart/change.js',{line:+b.dataset.shQty,quantity:Math.max(0,+b.dataset.v)}).then(render).finally(function(){busy(false)});return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&dr.classList.contains('is-on'))close()});
  document.querySelectorAll('.sh-hdr__cart').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();refresh();open()})});

  window.SHCart={open:function(){return refresh().then(open)},refresh:refresh,close:close};
})();
